
import { VNode } from 'vue';
import { InputCell, CellPosition } from 'vue/types/vue';



export class Notes {
  public v: string;
  public h: string;

  constructor(v: string = "", h: string = "") {
    this.v = v;
    this.h = h;
  }

  setVertical(note: string): void {
    this.v = note;
  }
  setHorizontal(note: string): void {
    this.h = note;
  }
  getVertical(): string {
    return this.v;
  }
  getHorizontal(): string {
    return this.h;
  }
}

export class Cell {

  public update: number = 0;
  public letter: string = "";
  public inputType: string = "";
  public state: string;
  public split: boolean = false;
  public arrow: string = "";
  public dash: string = "";
  public number: string = "";
  public marked: boolean = false;
  public selected: boolean = false;
  public dom: any;
  private position: CellPosition;


  public constructor(pos: CellPosition, state: string = "1") {

    this.state = state;
    this.position = pos;


  }

  public getId(): string {
    return `${this.getPos().x}${this.getPos().y}`;
  }
  public getPos(): CellPosition {
    return this.position;
  }

  public setStart(number: string): void {
    this.getDom().setStart(number);
  }

  public getStart(): string {
    return this.getDom().number;
  }
  public setArrow(dir: string): void {
    this.getDom().setArrow(dir);
  }
  public getArrow(): string {
    return this.getDom().arrow;
  }
  public setDash(dash: string): void {
    this.getDom().setDash(dash);
  }
  public getDash(): string {
    return this.getDom().dash;
  }
  public setSplit(split: boolean): void {
    this.getDom().setSplit(split);
  }
  public setState(state: string): void {
    if (state === "0") {
      this.clear();
      //this.setSplit("");
    }
    this.getDom().setState(state);
  }
  public getState(): string {
    return this.getDom().state;
  }
  public setLetter(letter: string): void {
    this.getDom().letter = letter;
  }
  public getLetter(): string {
    return this.getDom().letter;
  }
  public setDom(dom: InputCell): void {
    this.dom = dom;

  }
  public getDom(): InputCell {
    return this.dom;
  }

  public hasCorner(): boolean {
    return this.getDom().hasCorner;
  }
  public isDark(): boolean {
    return this.getDom().state === '0';
  }
  public isSpecial(): boolean {
    return this.getDom().state !== "1";
  }
  public isValid(): boolean {
    try {
      return this.position.x !== -1 && this.position.y !== -1;
    }
    catch (error: any) {
      return false;
    }
  }

  public isSelectable(): boolean {
    return this.getDom().isSelectable;
  }

  public clear(): void {
    const dom = this.getDom();
    this.setStart("");
    this.setArrow("");
    this.setDash("");
    this.setLetter("");
  }

  private updateCell(): void {
    this.update += 1;
  }

}



export const puzzleVOImpl = new Cell({ x: 0, y: 0 }, "1");


